export default {
    reset: () => {},
    goBack: () => {},
    navigate: () => {},
    setParams: () => {},
};
